import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';
import PropTypes from 'prop-types';

import LandingPageStyles from '../../../styles/LandingPageStyles';

const FormLabel = styled.label`
  color: ${colors.grayscaleCoolGray08};
  margin: 0.25rem 0;
  font-size: 15px;
  letter-spacing: -0.3px;
  line-height: 1.67;

     /* - TABLET VIEW - */
     @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        margin-bottom: 0px;
        margin-top: 0px;
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){

    }
  
`;

FormLabel.propTypes = {
    required: PropTypes.bool
};

export default FormLabel;


// WEBPACK FOOTER //
// ./src/components/Form/styles/FormLabel.js